import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['../../pop-ups.component.scss','./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
